import { Component, OnInit, Input } from '@angular/core';
import {Agent, Role, Status, Permission} from '../../../models';
import { AgentUtility } from '../../../util'

@Component({
  selector: 'app-left-block',
  templateUrl: './left-block.component.html',
  styleUrls: ['./left-block.component.css']
})
export class LeftBlockComponent implements OnInit {

  @Input() userLeftBlock: Agent = new Agent; 

  user: Agent = new Agent;

  constructor() { }

  ngOnInit() {
    this.user = AgentUtility.getUser();
  }

}
